// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  serviceWorker: true,
  demo: false,
  baseUrl: 'https://api.denefits.com/business/',
  socketurl: 'https://api.denefits.com/',
  socket_name_space: '/business/socket.io',
  app_version: 130,
  google_id: '964849874863-mtkk8s6gfm3iuvjq73p2lbh1dtuck4l0.apps.googleusercontent.com',
  app_type: 10,
  device_type: 0,
  device_token: 'Website',
  env: 't1',
  url: 'https://unsubscribe.denefits.com',
  business_url: 'https://testbusiness.denefits.com/v1',
  download_receipt_link: 'https://assets.denefits.com/tr/downloadReceipt.html?id=',
  plaid_redirect_url: 'https://testbusiness.denefits.com/app/profile',
  plaid_public_key: 'ccc1e7ed2525e866d48e2bba35afc5',
  persona_template_id: 'itmpl_NYm7N3R8oRKUEa7HTEdbkaNb',
  persona_env: 'sandbox',
  google_places_key: "AIzaSyDAzYGcvpIhlbjdB9TeTO1UF9AMLGqU1-0",
  parposal_link: 'https://testrequest.denefits.com',
  google_captcha_sitekey: "6LdfR24rAAAAACr4Tx-_o2pmNen7OU6IyZxqv56r",
  restApi: 'https://assets.denefits.com/DoctorTest.json',
  restApiihf: "https://assets.denefits.com/ihfDoctorTest.json"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
